const gerar_arquivo_de_transporte_escolar = [
  {
    path: "/gerar-arquivo-de-transporte-escolar",
    redirect: "/gerar-arquivo-de-transporte-escolar",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/gerar-arquivo-de-transporte-escolar",
        name: "gerar_arquivo_de_transporte_escolar",
        component: () =>
          import(
            "@/views/GerarArquivoDeTransporteEscolar/GerarArquivoDeTransporteEscolar.vue"
          ),
      },
    ],
  },
];

export { gerar_arquivo_de_transporte_escolar };
